const DATADOG_SITE = "datadoghq.com";
const DEFAULT_DATADOG_SOURCE = "next.js";
const LOG_INTAKE_URL = `https://http-intake.logs.${DATADOG_SITE}/api/v2/logs`;

type DatadogEnv = {
  apiKey: string;
  environment: string;
  logIntakeUrl: string;
  service: string;
  site: string;
  source: string;
};

/**
 * Resolve Datadog log-intake configuration at call time.
 *
 * Env is read lazily so this module can be imported from tests, client
 * components, and packages that do not have Datadog configured. Missing
 * `DATADOG_API_KEY` disables HTTP intake (console fallback) rather than
 * throwing at import.
 *
 * hi-www may omit `DATADOG_SERVICE` / `DATADOG_ENV` and fall back to the
 * public RUM values already set for the app.
 */
function datadogEnv(): DatadogEnv {
  return {
    apiKey: process.env.DATADOG_API_KEY ?? "",
    environment:
      process.env.DATADOG_ENV ?? process.env.NEXT_PUBLIC_DD_ENV ?? "",
    logIntakeUrl: LOG_INTAKE_URL,
    service:
      process.env.DATADOG_SERVICE ?? process.env.NEXT_PUBLIC_DD_SERVICE ?? "",
    site: DATADOG_SITE,
    source: process.env.DATADOG_SOURCE ?? DEFAULT_DATADOG_SOURCE,
  };
}

export { datadogEnv };
